export const getCurrentDate = () => {
  const date = new Date();
  let dd = date.getDate();
  let mm = date.getMonth() + 1; // January is 0!
  const yyyy = date.getFullYear();
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  if (dd < 10) {
    dd = `0${dd}`;
  }

  if (mm < 10) {
    mm = `0${mm}`;
  }

  let currentDate;
  let today;
  let prevDay;
  let dateNumber;
  let nextDay;
  let lbClosed = false;
  const month = months[date.getMonth()];

  // hack to make this leaderboard work for 19-20
  // dd = '21';
  const leaderboardDates = ['19', '20'];
  const startIndex = 0;
  const lastIndex = leaderboardDates.length - 1;

  if (dd == leaderboardDates[0]) {
    currentDate = `${dd}-${mm}-${yyyy}`;
    today = `${dd} ${month}`;
    nextDay = `${dd * 1 + 1} ${month}`;
    dateNumber = dd;
  } else if (dd == leaderboardDates[1]) {
    currentDate = `${dd}-${mm}-${yyyy}`;
    today = `${dd} ${month}`;
    nextDay = '';
    prevDay = `${dd - 1} ${month}`;
    dateNumber = dd;
  } else if (dd > leaderboardDates[lastIndex]) {
    dd = leaderboardDates[lastIndex];
    currentDate = `${dd}-${mm}-${yyyy}`;
    today = `${dd} ${month}`;
    nextDay = '';
    prevDay = `${dd - 1} ${month}`;
    dateNumber = dd;
    lbClosed = true;
  }
  return {
    currentDate,
    today,
    nextDay,
    prevDay,
    dateNumber,
    month,
    lbClosed,
    disable: dd < leaderboardDates[startIndex]
  };
};

export const timeleft = () => {
  // calculate
  const now = new Date();
  let hoursleft = 23 - now.getHours();
  let minutesleft = 59 - now.getMinutes();
  let secondsleft = 59 - now.getSeconds();

  // format 0 prefixes
  if (minutesleft < 10) minutesleft = `0${minutesleft}`;
  if (secondsleft < 10) secondsleft = `0${secondsleft}`;
  if (hoursleft < 10) hoursleft = `0${hoursleft}`;

  // display
  return `${hoursleft} ` + `h ${minutesleft} ` + `m`;
};
// window.setInterval(timeleft, 1000);

let canvas;

function setup() {
  canvas = createCanvas(windowWidth, windowHeight);
  textFont('Roboto Mono');
}

function draw() {
  background(0);

  stroke(255);
  noFill();

  const now = new Date();

  const mil = now.getMilliseconds();
  const sec = now.getSeconds() + mil / 1000;
  const s = sec / 60;
  const min = now.getMinutes() + s;
  const m = min / 60;
  const hou = (now.getHours() % 12) + m;
  const h = hou / 12;

  translate(width / 2, height / 2);

  const x = Math.min(width, height) * 0.9;
  const x2 = x * 0.9;
  const x3 = x * 0.8;

  strokeCap(SQUARE);
  strokeWeight((30 / 1000) * x);
  textAlign(CENTER, CENTER);

  push();
  rotate(-HALF_PI);

  arc(0, 0, x, x, 0, h * TAU);
  // arc(0, 0, x2, x2, 0, m * TAU);
  // arc(0, 0, x3, x3, 0, s * TAU);
  pop();

  noStroke();
  fill(255);

  textSize((100 / 1000) * x);
  const clockText = [floor(hou), floor(min), floor(sec)].map(n => `0${n}`.slice(-2)).join(':');
  text(clockText, 0, 0);
}

function windowResized() {
  resizeCanvas(windowWidth, windowHeight);
}

/*
   function to Extract date, month and year from the date
   Params :date
   return : Object containing date, month and year 
*/

export const getFieldsFromDateAsFormat = date => {
  const dobObj = new Date(date);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const months3ValArr = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  let dd = dobObj.getDate();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  const month = months[dobObj.getMonth()];
  const month3Val = months3ValArr[dobObj.getMonth()];
  let mm = dobObj.getMonth() + 1; // Starts from 0 i.e Jan is 0
  if (mm < 10) {
    mm = `0${mm}`;
  }

  const yyyy = dobObj.getFullYear();

  return { dd, mm, yyyy, month, month3Val };
};

// have to modify this
export function getExpiresFromResponse(res) {
  const { expires, date } = res.headers._headers;
  let expiresTime = expires;
  if (!expiresTime) {
    expiresTime = date[0];
  }
  expiresTime = new Date(expiresTime);
  expiresTime.setTime(expiresTime.getTime() + 4 * 3600 * 1000);
  return [expiresTime.toGMTString()];
}

export function setExpiresTimeInResponse({ res, state }) {
  // const { expires } = state.expires;
  //   if(expires){
  //     res.set({"expires":  expires});
  //   }
  // will remove this commented code later
  // if(false){
  //   res.set({"expires":  [ 'Wed, 16 Oct 2019 17:17:17 GMT' ]});
  // }else{
  //   res.set({"expires":  [ 'Wed, 16 Oct 2019 17:17:18 GMT' ]});
  // }
  // console.log("expires used===", isActual? "[ 'Wed, 16 Oct 2019 17:17:17 GMT' ]": "[ 'Wed, 16 Oct 2019 17:17:17 GMT' ]");
  // console.log("expires original===", expires, typeof expires);
}
export default function millisecondsToTime(duration) {
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  let days = Math.floor(duration / (1000 * 60 * 60 * 24));

  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  days = days < 10 ? `0${days}` : days;

  return {
    hours,
    minutes,
    seconds,
    days
  };
}
const differenceFromToday = date => {
  const date2 = new Date(date);
  const date1 = new Date();
  // To calculate the time difference of two dates
  const timeDifference = date2.getTime() - date1.getTime();
  // To calculate the no. of days between two dates
  try {
    return `${Math.round(timeDifference / (1000 * 3600 * 24))}`;
  } catch {
    return date;
  }
};
export const showCarrierInfoAfterXDays = (deliveryDate, days) => {
  const dateString = deliveryDate ? deliveryDate.split('T')?.[0] : '';
  const diff = differenceFromToday(dateString);
  // calculate abs difference
  const absDiff = Math.abs(Number(diff));

  return absDiff < days;
};

function AddMinutesToDate(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

export const calculateTime = min => {
  const currDate = new Date();
  const next = AddMinutesToDate(currDate, min);
  let hours = next.getHours();
  let minutes = next.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  return strTime;
};

// export const getDateTimePriceReveal  = (strEpoch) => {
//   const dateInstance = new Date(strEpoch);
//   const months = [
//     'January',
//     'February',
//     'March',
//     'April',
//     'May',
//     'June',
//     'July',
//     'August',
//     'September',
//     'October',
//     'November',
//     'December'
//   ];
//   const month = months[dateInstance.getMonth()];
//   const date = dateInstance.getDate();
//   const timeStr = dateInstance.toLocaleString('en-GB', { hour:'numeric', minute:'numeric', hour12:true });
//   const time = timeStr.split(' ')[0];
//   const meridian = timeStr.split(' ')[1].split('').join('.');
//   return `${month} ${date}, ${time} ${meridian}.`;
// }

export const formatGiftCardExpiry = date => {
  const { dd = '', month3Val = '', yyyy = '' } = getFieldsFromDateAsFormat(date || new Date());
  return `${dd} ${month3Val}, ${yyyy}`;
};

export const setGADateFormat = date => {
  if (!date) return null;
  const dobObj = new Date(date);
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const day = days[dobObj.getDay()];
  let dateData = dobObj.getDate();
  if (dateData < 10) {
    dateData = `0${dateData}`;
  }
  const month = months[dobObj.getMonth()];
  const year = dobObj.getFullYear();

  return `${day}, ${month} ${dateData} ${year}`;
};
